<template lang="html">
  <div class="columns">
    <div class="column is-3"
         style="margin-top: 6em; flex-grow: 0; display: flex; width:500px;flex-basis: unset;">
      <ReviewListFilterTeam/>
    </div>
    <div class="column is-7" style="padding-bottom:0px; margin-top: 5em; min-width: 940px;width:calc(100vw - 570px);">
      <FlowDetail :uid="$store.selected_review_uid"
                  v-if="$store.state.selected_review_uid != null"
                  :showPad="false">
      </FlowDetail>
      <div v-else class="has-text-centered has-text-grey" style="margin-top: 5em;">
        <div class="box" style="background-color: #f5f5f5; border: none;">
          <p class="is-size-5">Veuillez cliquer sur un élément de la liste pour voir les détails.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewListFilterTeam from '@/components/ReviewListFilterTeam.vue';
import EstablishmentListFilterTeam from '@/components/EstablishmentListFilterTeam.vue';
import FlowDetail from '@/components/FlowDetail.vue';

export default {
  name: 'team',
  components: {
    ReviewListFilterTeam,
    EstablishmentListFilterTeam,
    FlowDetail
  },
  mounted() {
    if (this.$route.params.uid) {
      this.$store.dispatch("select_review", this.$route.params.uid);
    }
  }
};
</script>


<style scoped>
.card {
  border-radius: 0.25rem;
}
</style>
